import React from 'react';
import { InfoCardVariants, TableColumn } from '@backstage/core-components';
import { EntityTable, useEntity } from '@backstage/plugin-catalog-react';
import {
  ApiEntity,
  Entity,
  RELATION_HAS_PART,
  RELATION_OWNER_OF,
} from '@backstage/catalog-model';
import { RelatedEntitiesCard } from '../RelatedEntitiesCard/RelatedEntitiesCard';

export interface HasApisCardProps {
  variant?: InfoCardVariants;
}

export const HasApisCard = (props: HasApisCardProps) => {
  function relationType(entity: Entity): string {
    if (entity.kind === 'Group') {
      return RELATION_OWNER_OF;
    }
    return RELATION_HAS_PART;
  }

  const { variant = 'gridItem' } = props;
  const { entity } = useEntity();

  const resourceEntityColumns: TableColumn<ApiEntity>[] = [
    EntityTable.columns.createEntityRefColumn({ defaultKind: 'api' }),
    EntityTable.columns.createSpecTypeColumn(),
    EntityTable.columns.createSpecLifecycleColumn(),
    EntityTable.columns.createMetadataDescriptionColumn(),
  ];

  const asResourceEntities = (entities: Entity[]): ApiEntity[] =>
    entities as ApiEntity[];

  return (
    <RelatedEntitiesCard
      variant={variant}
      title="APIs"
      entityKind="API"
      relationType={relationType(entity)}
      columns={resourceEntityColumns}
      asRenderableEntities={asResourceEntities}
    />
  );
};
